import '@sparta.global.vendors/jquery';
import marketingCodeUtil from '@sparta.auto-loans.utilities/marketing-code-utility/dist/es6.js';

/* global spaParams */

/**
 *
 * @class ApplyNowUtility
 */
class ApplyNowUtility {
  /**
   * Creates an instance of ApplyNowUtility.
   * @param {Object} options Utility Options
   * @memberof ApplyNowUtility
   */
  constructor(options) {
    this.options = options;
  }

  /**
   * Append ABPA URL
   * @returns {undefined}
   */
  appendABPAurl() {
    const applyBtnEls = [...document.querySelectorAll('.autoApply')];
    const abpaurl = spaParams.siteParams.abpaEndpoint + spaParams.siteParams.vlEndpointNew;

    // If marketing code is passed,
    // loop through all apply buttons on page and pass to marketing code utility
    applyBtnEls.forEach(el => {
      el.href = abpaurl;
      marketingCodeUtil.appendMarketingCode(el);
    });
  }
}
const applyNowEvent = new ApplyNowUtility();

export { applyNowEvent as default };
